import R from 'ramda';

const take = ({ takeLast }) => (segments) => {
  if (takeLast) {
    return R.takeLast(takeLast, segments);
  }

  return R.tail(segments);
};

const getPathSegments = ({ path = '', takeLast = 1 }) => R.compose(
  take({ takeLast }),
  R.split('/'),
  R.replace(/\/$/, ''),
)(path);

export default getPathSegments;
